import DOMPurify from 'dompurify'

const BLOCKED_TAGS = [
  'base', 'button', 'embed', 'form', 'iframe', 'input', 'link', 'math',
  'meta', 'object', 'script', 'select', 'style', 'svg', 'textarea'
]
const URL_ATTRIBUTES = new Set(['action', 'background', 'cite', 'data', 'formaction', 'href', 'poster', 'src', 'xlink:href'])

function isSafeUrl(value, node) {
  const url = String(value || '').trim()
  if (!url) return true
  // 邮件签名常把 Logo 以内嵌的 Base64 图片保存。仅放行不可执行的常见位图格式，
  // 不允许 SVG，避免 data URL 成为脚本注入入口。
  if (
    node?.tagName === 'IMG'
    && /^data:image\/(?:png|jpe?g|gif|webp);base64,[a-z0-9+/=\s]+$/i.test(url)
  ) return true
  if (/^(?:javascript|vbscript|data):/i.test(url)) return false

  try {
    const parsed = new URL(url, window.location.origin)
    return ['http:', 'https:', 'mailto:'].includes(parsed.protocol)
  } catch (error) {
    return false
  }
}

DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
  const name = String(data.attrName || '').toLowerCase()
  if (URL_ATTRIBUTES.has(name) && !isSafeUrl(data.attrValue, node)) {
    data.keepAttr = false
  }
})

DOMPurify.addHook('afterSanitizeAttributes', node => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer')
  }
})

/**
 * 净化所有将写入 DOM 的不可信 HTML：邮件、AI Markdown、富文本模板和附件预览。
 * 样式、表单与可执行/嵌入式元素默认被移除，URL 仅允许 http(s)、mailto、站内相对地址
 * 以及 IMG 标签上的常见 Base64 位图。
 */
export function sanitizeHtml(value) {
  return DOMPurify.sanitize(String(value || ''), {
    USE_PROFILES: { html: true },
    FORBID_TAGS: BLOCKED_TAGS,
    FORBID_ATTR: ['style', 'srcset', 'formaction', 'xlink:href'],
    ALLOW_DATA_ATTR: false
  })
}
